<ion-app>
  <ion-toast
    [isOpen]="toastService.isOpen"
    [message]="toastService.message"
    [color]="toastService.color"
    duration="2500"
    (didDismiss)="toastService.onDismissToast()">
  </ion-toast>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
